const events = {
  ORDER_MY_BOX: 'Order My Box',
};

export default events;
